<template>
	<div>
		<table class="message-table">
			<thead>
				<tr>
					<th>Events</th>
					<th>Message Title</th>
					<th>Opened</th>
					<th>Got It</th>
					<th>Learn More</th>
					<th>No Action</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="message in data" 
					:key="message.id">
					<td class="bold">{{ message.delayTitle }}</td>
					<td class="bold">{{ message.title }}</td>
					<router-link :to="getActionUrl('opened' ,message.id)"
						tag="td" class="link"
						:disabled="message.openedCount === 0">
						{{ message.openedCount }}
					</router-link>
					<router-link :to="getActionUrl('gotit', message.id)"
						tag="td" class="link"
						:disabled="message.acceptCount === 0">
						{{ message.acceptCount }}
					</router-link>
					<router-link :to="getActionUrl('learnmore', message.id)" 
						tag="td" class="link"
						:disabled="message.actionCount === 0">
						{{ message.actionCount }}
					</router-link>
					<router-link :to="getActionUrl('noaction', message.id)"
						tag="td" class="link"
						:disabled="message.noActionCount === 0">
						{{ message.noActionCount }}
					</router-link>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	name: 'action-table',
	props: {
		data: {
			type: Array
		},
		event: {
			type: Object
		}
	},
	methods: {
		getActionUrl(status, messageId) {
			return `/engagement/${this.$route.params.profileId}/${this.event.id}/${messageId}?status=${status}`
		}
	}
}
</script>

<style lang="scss" scoped>
table.message-table{
	border-collapse: collapse;
	margin-top: 20px;
	th{
		padding: 16px 18px;
		font-size: 14px;
		font-weight: normal;
		color: #666666;
		border-bottom: 2px solid #999999;
		text-align: left;
	}
	td{
		padding: 20px 16px;
		border-bottom: 1px solid #e2e2e2;
		font-size: 16px;
		color: #333333;
	}
	td.bold{
		font-weight: bold;
	}
	td.link{
		cursor: pointer;
		transition: background-color 0.4s ease;
	}
	td.link:hover{
		background-color: #fff9e4;
	}
	td.link[disabled]{
		pointer-events: none;
	}
}
</style>
